export default "__VITE_ASSET__1dcc3e31__"